import { useState } from "react";
import { Button } from "../../Atoms/Button/Button";
import Loader from "../../Atoms/Loader/Loader";
import SuccessCasesCard from "../../Molecules/SuccessCasesCard/SuccessCasesCard";
import usePosts from "../../../hooks/usePosts";
import capitalizedFirstLetter from "../../../Services/capitalizedFirstLetter";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import content from "../../Pages/SuccessCases/content";


const SuccessCasesCardsSection = () => {
	const { language } = useLanguageCtx();
	const [showButton, setShowButton] = useState(true);
	const { loading, posts, changePaginationNumb, paginationNumb } =
		usePosts("casos-exitos", 3, setShowButton);

	return (
		<>
			<div className={`flex column ${!showButton && "bottom-space-section"}`}>
				{loading && paginationNumb === 0 ? (
					<div className="bottom-space-section">
						<Loader />
					</div>
				) : (
					posts.map((post, index) => (
						<SuccessCasesCard
							image={post.multimedia[0].url}
							leftImage={index % 2 === 0}
							yellowTitle={post.pais_esp}
							boldTitle={capitalizedFirstLetter(post.titulo_esp)}
							content={post.contenido_esp}
							linkRoute={`/casos-de-exito/${post.slug}`}
							linkText={content[language].card_button_text}
							key={post.slug}
						/>
					))
				)}
			</div>
			{loading && paginationNumb > 0 && (
				<div className="top-space-section">
					<Loader />
				</div>
			)}
			{showButton && posts.length > 0 && (
				<div className="flex center-content-items top-space-section bottom-space-section">
					<Button
						type="button light-blue outline"
						content={content[language].final_button_text}
						clickHandler={changePaginationNumb}
					/>
				</div>
			)}
		</>
	);
};

export default SuccessCasesCardsSection;
